import styled from "styled-components";

const Overflow = styled.div`
    flex: 1;
`;

export default Overflow;